import React from "react";
import { cn } from "@/lib/utils";

export const GlassCard = ({ children, className = "", glow = "green", sheen = true, ...props }) => {
  const glowHover =
    glow === "purple"
      ? "hover:border-[color:var(--stroke-p)] hover:shadow-[0_18px_50px_rgba(0,0,0,0.55),0_0_0_1px_rgba(160,32,240,0.22),0_0_30px_rgba(160,32,240,0.16)]"
      : "hover:border-[color:var(--stroke-g)] hover:shadow-[0_18px_50px_rgba(0,0,0,0.55),0_0_0_1px_rgba(57,255,20,0.22),0_0_30px_rgba(57,255,20,0.16)]";

  return (
    <div
      className={cn(
        "glass rounded-[var(--radius-card)] shadow-[var(--shadow-soft)] hover-lift",
        sheen && "sheen",
        glowHover,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
